import axios from 'axios';
import {apiUrl} from "../../constants/config";

export default {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        getRegistrationByCode({}, code) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/registration/code/' + code).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        updatePOInfo({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/registration/' + payload.code, payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        attendSession({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/attend/' + payload.code + '/' + payload.id + '/' + payload.type, {}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        removeEnrollment({}, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(apiUrl + 'api/registration/enroll/' + payload.code + '/' + payload.id, {}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        my247edLookup({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/lookup/', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        my247edTransfer({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/transfer/' + payload.code, payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        activateReg({}, code) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/activate/' + code, {}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getDistricts({}) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/district/').then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getSchoolsByDistrict({}, district) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/school/' + district).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        sendPoByEmail({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/send/' + payload.code, {email: payload.email}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        sendConfirmByEmail({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/registration/confirm/' + payload.code, {}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getCerts({}, id) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/registration/certs/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getIds({}, id) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/registration/ids/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        updateRegistration({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/registration/reg/' + payload.id, payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        updateCert({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/registration/cert/' + payload.id, payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        deleteRegistration({}, id) {
            return new Promise((resolve, reject) => {
                axios.delete(apiUrl + 'api/registration/' + id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
